import React, { useEffect, useState } from "react";
import { dateFormator, mapTableRows } from "../../../../utils";
import {
  Avatar,
  Backdrop,
  Button,
  CopyToClipboard,
  DevNote,
  DropdownMenu,
  FormFieldSet,
  InvoiceModals,
  LogoLoader,
  NewTable,
  showToast,
  SmartTooltip,
  TableAdv,
  ToolTip,
} from "../../../../components";
import InvoiceDetails from "./InvoiceDetails";
import InvoiceFilters from "./InvoiceFilters";
import { usePagination } from "../../../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import {
  addInvoicesStart,
  getAllInvoicesStart,
  getCurrentInvoiceStart,
} from "../../../../redux/slices/invoices/invoicesSlice";
import { handleInvoiceDownload } from "./InvoiceDetails";
import dayjs from "dayjs";
import qb from "../../../../assets/qb.svg";
import QbAnimationLoading from "../../../../components/Module/Invoices/InvoiceModals/QbAnimationLoading";
import axios from "axios";
import { WORKFORCE_API_URL } from "../../../../redux/apiConfig";
import InvoiceViewModal from "./Modals/InvoiceViewModal";
import EditInvoice from "./EditInvoice";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import { sendEmail } from "../../../../utils/wf/email";
import ResendModal from "../Modals/ResendModal";
export const handleDownloadPdf = async (invoiceData, loginUserData) => {
  try {
    const invoiceObj = {
      company: {
        name: "TekTree LLC",
        address:
          [
            invoiceData?.address?.from?.city,
            invoiceData?.address?.from?.state,
            invoiceData?.address?.from?.country,
            invoiceData?.address?.from?.zipCode,
          ]
            ?.filter(Boolean)
            ?.join(", ") || "-",
        contact: "+1 (123) 456-7890",
        email: "accounts@tektreeinc.com",
        website: "www.tektreeinc.com",
        companyLogo: loginUserData?.organizationId?.logo?.company || "",
        backgroundLogo: loginUserData?.organizationId?.logo?.company || "",
        additionalInfo: invoiceData?.additionalInfo || "",
      },
      invoiceDeta: {
        amounts: {
          invoiced: invoiceData?.amounts?.invoiced || 0,
          due: invoiceData?.amounts?.due || 0,
        },
        name: invoiceData?.clientId?.businessName || "-",
        address:
          [
            invoiceData?.address?.billing?.city,
            invoiceData?.address?.billing?.state,
            invoiceData?.address?.billing?.country,
            invoiceData?.address?.billing?.zipCode,
          ]
            ?.filter(Boolean)
            ?.join(", ") || "-",
        invoiceNumber: invoiceData?.invoiceNum || "-",
        invoiceDate: invoiceData?.invoiceDate || "-",
        shippedDate: invoiceData?.shippedDate || "-",
        netTerms: invoiceData?.netTerms || "-",
        dueDate: invoiceData?.dueDate || "-",
        invoicedItems:
          invoiceData?.serviceSummary?.map((data) => ({
            item: data?.ss || "-",
            description: data?.activity || "-",
            quantity: data?.quantity || 0,
            price: data?.rate || 0,
            discount: 0,
          })) || [],
      },
    };
    const subTotal = invoiceObj?.invoiceDeta?.invoicedItems.reduce(
      (sum, item) => sum + (item.quantity * item.price - (item.discount || 0)),
      0,
    );
    const updatedData = {
      ...invoiceObj,
      invoiceDeta: {
        ...invoiceObj?.invoiceDeta,
        subTotal: subTotal,
        discountTotal:
          invoiceObj?.invoiceDeta?.amounts?.invoiced - subTotal || 0,
        invoiceTotal: invoiceObj?.invoiceDeta?.amounts?.invoiced || 0,
        dueTotal: invoiceObj?.invoiceDeta?.amounts?.due || 0,
        currency: "USD",
      },
    };
    await handleInvoiceDownload(updatedData);
  } catch (error) {
    console.error("Error downloading pdf:", error);
  }
};

export const handleResendInvoice = async (
  mailDetails,
  currentInvoices,
  setIsMailSaving,
  setIsResendModalOpen,
) => {
  console.log(mailDetails);
  try {
    setIsMailSaving(true);
    if (!mailDetails?.emails?.selectedUsers?.length) {
      showToast("Please select at least one recipient", "error", 5000);
      setIsMailSaving(false);
      return;
    }
    const res = await sendEmail(
      {
        to: mailDetails?.emails?.selectedUsers?.map((data) => data.email) || [],
        cc: mailDetails?.emails.ccUsers?.map((data) => data.email) || [],
        bcc: mailDetails?.emails.bccUsers?.map((data) => data.email) || [],
        subject: mailDetails.subject,
        html: mailDetails.body,
      },
      [
        ...(mailDetails?.attachments?.includes(1)
          ? [
              {
                type: "INVOICE_PDF",
                params: {
                  invoiceId: currentInvoices?.uiid || null,
                },
              },
            ]
          : []),
        ...(mailDetails?.attachments?.includes(2)
          ? [
              {
                type: "TS_FILES_PDF",
                params: {
                  timesheetIds:
                    currentInvoices?.timesheetRef
                      ?.flatMap((ref) => ref.id)
                      ?.map((ts) => ts?.uiid) || [],
                },
              },
            ]
          : []),
      ],
    );
    if (res?.success) {
      showToast("Invoice Resent Successfully", "success", 5000);
      setIsResendModalOpen(false);
    }
  } catch (error) {
    showToast("Failed to resend invoice", "error", 5000);
  } finally {
    setIsMailSaving(false);
  }
};

const AllInvoices = () => {
  const dispatch = useDispatch();
  const { value } = useSelector((state) => state.totalCount);
  const totalCount = value?.invoices?.data || 0;
  const { allInvoices, currentInvoices, loading } = useSelector(
    (state) => state.invoices,
  );
  const isLoading = loading;
  const allInvoicesTableData = allInvoices?.data?.[0]?.data || [];
  console.log({ allInvoicesTableData });
  const allInvoicesCount = allInvoices?.data?.[0]?.total?.[0]?.count || 0;
  const [sortConfig, setSortConfig] = useState({
    field: "uiid",
    direction: -1,
  });
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      // dispatch(getAccountPayablesStart({ page: newPage, limit: newLimit }));
    },
  );
  const [activeModal, setActiveModal] = useState(null);
  const [viewModal, setViewModal] = useState(false);
  const [showInvoiceDetails, setShowInvoiceDetails] = useState(false);
  const [showEditInvoice, setShowEditInvoice] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [qbLoading, setQbLoading] = useState(false);
  const [forceRerenderKey, setForceRerenderKey] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const { userData: loginUserData } = useLoginUser();
  const [downloadId, setDownloadId] = useState(null);
  const [resendId, setResendId] = useState(null);
  const [isResendModalOpen, setIsResendModalOpen] = useState(false);
  const [isMailSaving, setIsMailSaving] = useState(false);
  const [selEmployees, setSelEmployees] = useState("");
  const [selClients, setSelClients] = useState("");
  const [dateRange, setDateRange] = useState({ from: null, to: null });
  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    if (downloadId && currentInvoices?.uiid === downloadId) {
      handleDownloadPdf(currentInvoices, loginUserData);
      setDownloadId(null);
    }
  }, [currentInvoices, downloadId, loginUserData]);

  useEffect(() => {
    if (resendId && currentInvoices?.uiid === resendId) {
      setIsResendModalOpen(true);
      setResendId(null);
    }
  }, [currentInvoices, resendId]);
  // Reset page to 1 whenever any filter changes
  useEffect(() => {
    setPage(1);
  }, [selEmployees, selClients, dateRange, setPage]);

  const handleClickInvoiceNumber = (row) => {
    setSelectedInvoice(row);
    setShowInvoiceDetails(true);
    dispatch(
      getCurrentInvoiceStart({
        filters: { uiid: { type: "NONE", value: row.uiid } },
        coll: "Invoice",
        ref: "Client Employee Placement Timesheet",
        // incl: ["businessName uiid", "firstName lastName"],
        incl: ["", "firstName lastName", "", "attachments"],
      }),
    );
  };
  const handleCloseModal = () => setActiveModal(null);
  const formatCurrency = (amount) => {
    if (typeof amount !== "number") {
      return `$0.00`;
    }
    return `$${Number(amount).toLocaleString()}`;
  };

  const columns = [
    {
      key: "invoiceNum",
      label: "Invoice Number",
      render: (row) => (
        <div className="flex items-center gap-3 group">
          <div
            className={`flex gap-2 items-center cursor-pointer ${
              row?.qbSync?.id
                ? "text-success"
                : row?.qbSync?.error
                  ? "text-danger"
                  : "text-linkblue"
            } `}
            onClick={() => {
              handleClickInvoiceNumber(row);
            }}
          >
            <span className="material-symbols-rounded text-[14px] mr-[2px] ">
              mark_as_unread
            </span>
            {row.invoiceNum}
          </div>

          {/* Actions section - hidden by default, shown on hover */}
          <div className="flex items-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            <SmartTooltip
              noicon
              description={
                row?.qbSync?.id ? "Synced with QB" : "Not synced with QB"
              }
              tooltipPosition="top"
              portal={true}
            >
              <div className="flex items-center justify-center w-[18px] h-[18px] mr-1">
                <img
                  src={row?.qbSync?.id ? "/QB.svg" : "/QB Icon-off.svg"}
                  alt="QuickBooks"
                  className="w-[20px] h-[20px]"
                />
              </div>
            </SmartTooltip>
            <SmartTooltip
              noicon
              description="View Invoice PDF"
              tooltipPosition="top"
              portal={true}
            >
              <Button
                type={"icon"}
                variant="text"
                color="black"
                icon={"description"}
                className="!justify-start py-1"
                size="xs-sm"
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(
                    getCurrentInvoiceStart({
                      filters: { uiid: { type: "NONE", value: row.uiid } },
                      coll: "Invoice",
                      ref: "Client Employee Placement Timesheet",
                      incl: ["", "firstName lastName", "", "attachments"],
                    }),
                  );
                  setViewModal(true);
                }}
              />
            </SmartTooltip>
            {/* <Button
              type={"icon"}
              variant="text"
              color="black"
              icon={"description"}
              className="!justify-start py-1"
              size="xs-sm"
            /> */}
            <DropdownMenu
              MenuSection={
                <div className="flex flex-col">
                  <Button
                    title={"Edit"}
                    variant="text"
                    color="black"
                    className="!justify-start py-1"
                    icon={"edit_square"}
                    size="xs-sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedInvoice(row);
                      setShowEditInvoice(true);
                      dispatch(
                        getCurrentInvoiceStart({
                          filters: { uiid: { type: "NONE", value: row.uiid } },
                          coll: "Invoice",
                          ref: "Client Employee Placement Timesheet",
                          incl: ["", "firstName lastName", "", "attachments"],
                        }),
                      );
                    }}
                  />
                  <Button
                    icon={"download"}
                    variant="text"
                    color="black"
                    className="!justify-start py-1"
                    title={"Download PDF"}
                    size="xs-sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      setDownloadId(row.uiid);
                      dispatch(
                        getCurrentInvoiceStart({
                          filters: { uiid: { type: "NONE", value: row.uiid } },
                          coll: "Invoice",
                          ref: "Client Employee Placement Timesheet",
                          incl: ["", "firstName lastName", "", "attachments"],
                        }),
                      );
                    }}
                  />
                  <Button
                    icon={"send"}
                    variant="text"
                    color="black"
                    className="!justify-start py-1"
                    title={"Send Reminder to Invoice Recipients"}
                    size="xs-sm"
                  />
                  <Button
                    icon={"outgoing_mail"}
                    variant="text"
                    color="black"
                    className="!justify-start py-1"
                    title={"Resend Invoice"}
                    size="xs-sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      setResendId(row.uiid);
                      dispatch(
                        getCurrentInvoiceStart({
                          filters: { uiid: { type: "NONE", value: row.uiid } },
                          coll: "Invoice",
                          ref: "Client Employee Placement Timesheet",
                          incl: [
                            "businessName roleContacts",
                            "firstName lastName",
                            "",
                            "attachments",
                          ],
                        }),
                      );
                    }}
                  />
                  <Button
                    icon={"mark_as_unread"}
                    variant="text"
                    color="black"
                    className="!justify-start py-1"
                    title={"Submit Invoice"}
                    size="xs-sm"
                    disabled={true}
                  />
                  <Button
                    icon={"delete"}
                    variant="text"
                    color="black"
                    className="!justify-start py-1"
                    title={"Delete"}
                    size="xs-sm"
                  />
                </div>
              }
            >
              <Button
                icon="more_vert"
                type="icon"
                variant="text"
                color="black"
                size="sm"
              />
            </DropdownMenu>
          </div>
        </div>
      ),
    },
    {
      key: "employeeName",
      label: "Employee Name",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row.employeeName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="flex items-center gap-1 line-clamp-1!">
            {row.employeeName}
          </div>
        </SmartTooltip>
      ),
    },
    {
      key: "clientName",
      label: "Client",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row.clientName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="flex items-center gap-1 line-clamp-1!">
            {row.clientName}
          </div>
        </SmartTooltip>
      ),
    },
    {
      key: "invoiceDate",
      label: "Invoice Date",
      sortfun: (direction) => handleSort("invoiceDate", direction),
      render: (row) => dateFormator(row.invoiceDate, "month-day-year"),
    },
    {
      key: "dueDate",
      label: "Invoice Due Date",
      sortfun: (direction) => handleSort("dueDate", direction),
      render: (row) => dateFormator(row.dueDate, "month-day-year"),
    },
    {
      key: "invoicedAmount",
      label: "Invoiced Amount",
      render: (row) => {
        return <div>{formatCurrency(row?.amounts?.invoiced)}</div>;
      },
    },
    {
      key: "receivedAmount",
      label: "Received Amount",
      render: (row) => {
        return <div>{formatCurrency(row?.amounts?.received)}</div>;
      },
    },
    {
      key: "memo",
      label: "Statement Memo",
      width: "min-w-[350px]! max-w-[350px]!",
      render: (row) => (
        <SmartTooltip
          description={row.memo}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="flex items-center gap-3 group">
            <div
              className={`flex items-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 ${
                row?.memo === "-" ? "invisible" : "visible"
              }`}
            >
              <CopyToClipboard
                tooltipPosition={"left"}
                title={"Statement Memo"}
                content={row?.memo}
              />
            </div>
            <div className="line-clamp-1!">{row?.memo}</div>
          </div>
        </SmartTooltip>
      ),
    },
    {
      key: "pastDueInDays",
      label: "Past Due in Days",
      render: (row) => {
        if (!row.dueDate || row.dueDate === "-") {
          return "-";
        }
        const dueDate = dayjs(row.dueDate);
        const today = dayjs().startOf("day"); // Ensures time doesn't affect result
        const pastDueDays = today.diff(dueDate, "day");
        return pastDueDays;
      },
    },
  ];

  const mappedRows = mapTableRows(
    allInvoicesTableData?.map((a) => ({ id: a._id, ...a })) || [],
    columns,
  );
  const handleSort = (field, direction) => {
    setSortConfig({
      field,
      direction: direction === "asc" ? 1 : -1,
    });
  };
  useEffect(() => {
    dispatch(
      totalCountStart({
        collection: "invoices",
        coll: "Invoice",
        //filters: item.filters,
        filters: {
          "version.isLatest": {
            type: "NONE",
            value: true,
          },
        },
      }),
    );
    dispatch(
      getAllInvoicesStart({
        limit,
        page,
        useAggregate: true,
        sort: { [sortConfig.field]: sortConfig.direction },
        // filters: {
        //   search: { type: "SEARCH", value: searchValue },
        //   "version.isLatest": {
        //     type: "NONE",
        //     value: true,
        //   },
        // },
        filters: {
          // search: { type: "SEARCH", value: searchValue },
          placementTS: {
            type: "AG_INVOICE_SEARCH",
            value: [searchValue, ""],
          },
          "version.isLatest": { type: "NONE", value: true },
          ...(selEmployees && {
            employeeId: { type: "IN", value: [selEmployees.value] },
          }),
          ...(selClients && {
            clientId: { type: "IN", value: [selClients.value] },
          }),
          ...((dateRange?.from || dateRange?.to) && {
            invoiceDate:
              dateRange.from && dateRange.to
                ? { type: "BETWEEN", value: [dateRange.from, dateRange.to] }
                : dateRange.from
                  ? { type: "GTE", value: dateRange.from }
                  : { type: "LTE", value: dateRange.to },
          }),
        },
        coll: "Invoice",
        // ret:"uiid"
        // ret: "invoiceNum employeeId clientId invoiceDate shippedDate dueDate amounts currency dueDate uiid memo qbSync",
        ret: "",
        ref: "Client Employee",
        // incl: ["businessName uiid", "firstName lastName"],
        incl: ["", "firstName lastName"],
      }),
    );
  }, [
    dispatch,
    page,
    limit,
    sortConfig,
    forceRerenderKey,
    searchValue,
    selEmployees,
    selClients,
    dateRange,
  ]);

  const forceRerender = () => {
    console.log("F render:::::");
    setForceRerenderKey((prevKey) => prevKey + 1);
  };

  // Use forceRerenderKey in your component to trigger re-renders
  // Example: <div key={forceRerenderKey}>...</div>

  const handleQbSync = async (entity) => {
    if (selectedRowIds.length === 0) {
      showToast("Please select at least one invoice", "info", 5000);
      return;
    }
    let baseUrl = WORKFORCE_API_URL;
    try {
      setQbLoading(true);

      const selectedIds = selectedRowIds;
      const invoiceData = allInvoicesTableData?.filter((invoice) =>
        selectedIds.includes(invoice._id),
      );

      let successCount = 0;
      let failedCount = 0;

      const buildClientPayload = (data) => ({
        postActions: ["AddQBToClient"],
        payload: {
          businessName: data?.businessName || "",
          uiid: data?.uiid || null,
          email: data?.email || [],
          phone: (data?.phone || []).map((p) => ({
            code: p?.code || "",
            number: String(p?.number || ""),
          })),
          roleContacts: (data?.roleContacts || []).map((rc) => ({
            role: rc?.role || "",
            email: rc?.email || [],
            phone: (rc?.phone || []).map((p) => ({
              code: p?.code || "",
              number: String(p?.number || ""),
            })),
          })),
          federalId: data?.federalId || "",
          website: data?.website || "",
          recordStatus: data?.recordStatus || null,
          ownership: data?.ownership || null,
          generalInfo: data?.generalInfo || null,
          contacts: data?.contacts || [],
          additionalInfo: data?.additionalInfo || "",
          documents: (data?.documents || []).map((doc) => ({
            placement: doc?.placement || [],
            list: doc.list || [],
          })),
          placements: data?.placements || [],
          addedBy: data?.addedBy || null,
          addedOn: data?.addedOn || new Date().toISOString(),
        },
      });

      const buildInvoicePayload = (invoice) => {
        const obj = invoice;
        return {
          ...(obj?.qbSync?.id && { qbSync: obj.qbSync }),
          uiid: obj?.uiid || null,
          clientId: obj?.clientId.uiid || null,
          invoiceCreatedBy: obj?.invoiceCreatedBy || null,
          invoiceNum: obj?.invoiceNum || null,
          poNum: obj?.poNum || null,
          type: obj?.type || null,
          frequency: obj?.frequency || null,
          frequencyPeriod: obj?.frequencyPeriod || null,
          status: obj?.status || null,
          inclPOEmail: obj?.inclPOEmail || null,
          employeeId: obj?.employeeId._id || null,
          jobId: obj?.jobId._id || null,
          timesheet: obj?.timesheet || null,
          address: {
            billing: {
              ...(obj?.address.billing || null),
              zipCode: obj?.address.billing.zipCode || "",
            },
            from: {
              ...(obj?.address.from || null),
              zipCode: obj?.address.from.zipCode || "",
            },
          },
          netTerms: obj?.netTerms || null,
          invoiceDate: obj?.invoiceDate || null,
          shippedDate: obj?.shippedDate || null,
          dueDate: obj?.dueDate || null,
          location: obj?.location || null,
          amounts: obj?.amounts || null,
          recipients: obj?.recipients || null,
          serviceSummary: obj?.serviceSummary
            ? obj?.serviceSummary
                .filter(
                  (ele) =>
                    ele !== null &&
                    ele.amount !== null &&
                    ele.quantity !== null &&
                    ele.rate !== null,
                )
                .map(
                  ({
                    ss,
                    activity,
                    quantity,
                    rate,
                    amount,
                    attachments,
                    inclMailAttch,
                  }) => ({
                    ss,
                    activity,
                    quantity,
                    rate,
                    amount: +(Number(quantity) * Number(rate)).toFixed(2),
                    attachments,
                    inclMailAttch,
                  }),
                )
            : [],
          finalBill: {
            subTotal: obj?.finalBill.subTotal || null,
            discounts: obj?.finalBill.discounts.map(
              ({ name, type, value }) => ({
                name,
                type,
                value,
              }),
            ),
          },
          notes: obj?.notes || null,
          inclNotesPdf: obj?.inclNotesPdf || null,
          memo: obj?.memo || null,
          memoPeriod: obj?.memoPeriod || null,
          additionalInfo: obj?.additionalInfo || null,
          currency: obj?.currency || null,
          addedBy: obj?.addedBy || null,
          addedOn: obj?.addedOn || null,
          attachments: [],
          payableTo: "",
          category: "",
          class: "",
        };
      };

      for (const invoice of invoiceData) {
        const clientData = invoice.clientId || {};
        const isClientSynced = Boolean(clientData?.qbSync?.id);

        if (!isClientSynced) {
          try {
            const clientPayload = buildClientPayload(clientData);
            await axios.post(`${baseUrl}/qb/customers`, clientPayload, {
              headers: { "Content-Type": "application/json" },
              withCredentials: true,
            });
          } catch (err) {
            console.error("Customer Sync Failed:", err.response || err);
            failedCount++;
            continue;
          }
        }

        const isInvoiceSynced = Boolean(invoice?.qbSync?.id);
        const invoicePayload = buildInvoicePayload(invoice);

        try {
          if (!isInvoiceSynced) {
            const res = await axios.post(
              `${baseUrl}/qb/${entity}`,
              {
                postActions: ["AddQBToInvoice"],
                payload: invoicePayload,
              },
              {
                withCredentials: true,
                headers: { "Content-Type": "application/json" },
              },
            );
            console.log("post invoice res", res);
            let failedUploads = 0;

            if (
              invoicePayload?.serviceSummary?.length > 0 ||
              invoicePayload?.serviceSummary?.some(
                ({ attachments }) => attachments?.length > 0,
              )
            ) {
              for (const service of invoicePayload.serviceSummary) {
                if (service?.attachments?.length > 0) {
                  for await (const file of service.attachments) {
                    try {
                      const filesRes = await axios.post(
                        `${baseUrl}/qb/uploads`,
                        {
                          payload: {
                            uiid: invoicePayload.uiid,
                            fileName: service?.ss,
                            inclToMail: !!service.inclMailAttch,
                            parentRef: {
                              entity: "Invoice",
                              id: res?.data?.data?.response?.Id,
                            },
                            attachment: file,
                          },
                        },
                        {
                          headers: { "Content-Type": "application/json" },
                          withCredentials: true,
                        },
                      );
                    } catch (err) {
                      failedUploads++;
                    }
                  }
                }
              }
              if (failedUploads > 0) {
                dispatch(
                  addInvoicesStart({
                    coll: "Invoice",
                    uiid: invoicePayload?.uiid,
                    qbId: res?.data?.data?.response?.Id,
                    syncFromQB: true,
                    supressToast: true,
                    onSuccess: () => {
                      forceRerender();
                    },
                  }),
                );
                showToast(
                  `${failedUploads} attachment${
                    failedUploads > 1 ? "s" : ""
                  } failed to upload`,
                  "info",
                  3000,
                );
              } else {
                dispatch(
                  addInvoicesStart({
                    coll: "Invoice",
                    uiid: invoicePayload?.uiid,
                    qbId: res?.data?.data?.response?.Id,
                    syncFromQB: true,
                    supressToast: true,
                    onSuccess: () => {
                      forceRerender();
                    },
                  }),
                );
              }
            }

            successCount++;
          } else {
            const res = await axios.post(
              `${baseUrl}/qb/${entity}`,
              {
                update: true,
                postActions: ["AddQBToInvoice"],
                payload: invoicePayload,
              },
              {
                withCredentials: true,
                headers: { "Content-Type": "application/json" },
              },
            );
            let failedUploads = 0;

            // if (
            //   invoicePayload?.serviceSummary?.length > 0 ||
            //   invoicePayload?.serviceSummary?.some(
            //     ({ attachments }) => attachments?.length > 0
            //   )
            // ) {
            //   for (const service of invoicePayload.serviceSummary) {
            //     if (service?.attachments?.length > 0) {
            //       for await (const file of service.attachments) {
            //         try {
            //           const filesRes = await axios.post(
            //             `${baseUrl}/qb/uploads`,
            //             {
            //               payload: {
            //                 uiid: invoicePayload.uiid,
            //                 fileName: service?.ss,
            //                 inclToMail: !!service.inclMailAttch,
            //                 parentRef: {
            //                   entity: "Invoice",
            //                   id: res?.data?.data?.response?.Id,
            //                 },
            //                 attachment: file,
            //               },
            //             },
            //             {
            //               headers: { "Content-Type": "application/json" },
            //               withCredentials: true,
            //             }
            //           );
            //         } catch (err) {
            //           failedUploads++;
            //         }
            //       }
            //     }
            //   }
            // }

            // if (failedUploads > 0) {
            //   showToast(
            //     `${failedUploads} attachment${
            //       failedUploads > 1 ? "s" : ""
            //     } failed to upload`,
            //     "info",
            //     3000
            //   );
            // }
            // dispatch(
            //   addInvoicesStart({
            //     coll: "Invoice",
            //     uiid: invoicePayload?.uiid,
            //     qbId: invoicePayload?.qbSync?.id,
            //     syncFromQB: true,
            //     supressToast:true
            //   })
            // );
            successCount++;
          }
        } catch (err) {
          console.error("Invoice Sync Error:", err);
          failedCount++;
        }
      }

      showToast(
        `QB Update Done: ${successCount} succeeded, ${failedCount} failed.`,
        failedCount > 0 ? "warning" : "success",
        6000,
      );
    } catch (err) {
      console.error("Unexpected QB Sync Error:", err);
      showToast("Unexpected Error Occurred", "error", 5000);
    } finally {
      setQbLoading(false);
      forceRerender();
    }
  };

  const handleQbDispatchSync = async () => {
    try {
      setQbLoading(true);
      if (selectedRowIds.length === 0) {
        showToast("Please select at least one invoice", "info", 5000);
        return;
      }

      const selectedIds = selectedRowIds;
      const invoiceData = allInvoicesTableData?.filter((invoice) =>
        selectedIds.includes(invoice._id),
      );
      console.log({ selectedIds, invoiceData, allInvoicesTableData });

      let successCount = 0;
      let notSyncedCount = 0;

      for (const invoice of invoiceData) {
        if (!invoice?.qbSync?.id) {
          notSyncedCount++;
          continue;
        }

        try {
          await new Promise((resolve) => {
            dispatch(
              addInvoicesStart({
                coll: "Invoice",
                uiid: invoice?.uiid,
                qbId: invoice?.qbSync?.id,
                syncFromQB: true,
                supressToast: true,
                onSuccess: () => {
                  successCount++;
                  resolve();
                },
                onError: () => {
                  notSyncedCount++;
                  resolve();
                },
              }),
            );
          });
        } catch (error) {
          console.error("Error during sync", error);
        }
      }

      showToast(
        `QB Sync Completed: ${successCount} succeeded, Update ${notSyncedCount} Invoice's to sync`,
        successCount > 0 ? "success" : "warning",
        4000,
      );
    } catch (error) {
      console.error("Error during sync", error);
    } finally {
      setQbLoading(false);
      forceRerender();
    }
  };

  const handleSearch = (keyname, value) => {
    setSearchValue(value);
  };

  return (
    <div className="flex-1 flex overflow-hidden">
      {showInvoiceDetails ? (
        <InvoiceDetails
          onBack={() => {
            setShowInvoiceDetails(false);
            setSelectedInvoice(null);
            forceRerender();
          }}
          invoiceData={selectedInvoice}
          setEditInvoice={() => {
            // Edit logic can go here
          }}
        />
      ) : showEditInvoice ? (
        <EditInvoice
          onBack={() => {
            setShowEditInvoice(false);
            setSelectedInvoice(null);
            forceRerender();
          }}
          currentInvoices={currentInvoices}
        />
      ) : (
        <TableAdv
          tableId={"invoices_allinvoicestable"}
          defaultSelectedRows={selectedRowIds}
          showCheckbox
          rows={mappedRows}
          columns={columns}
          serverPagination={true}
          // totalCount={totalCount}
          totalCount={allInvoicesCount}
          onSelectionChange={(selected) => {
            setSelectedRowIds(selected);
          }}
          toolbarLeft={{
            search: false,
            add: [
              {
                component: (
                  <SmartTooltip
                    description="Filters"
                    noicon
                    tooltipPosition="bottom"
                  >
                    <Button
                      type="icon"
                      icon={showFilters ? "filter_alt_off" : "filter_alt"}
                      variant="text"
                      color={showFilters ? "danger" : "black"}
                      onClick={() => setShowFilters(!showFilters)}
                    />
                  </SmartTooltip>
                ),
              },
              ...(showFilters
                ? [
                    {
                      component: (
                        <InvoiceFilters
                          selEmployees={selEmployees}
                          setSelEmployees={setSelEmployees}
                          selClients={selClients}
                          setSelClients={setSelClients}
                          dateRange={dateRange}
                          setDateRange={setDateRange}
                        />
                      ),
                    },
                  ]
                : []),
            ],
          }}
          // toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
          toolbarRight={{
            search: !showFilters,
            filter: true,
            add: [
              {
                component: (
                  <div className="flex items-center">
                    {/* <Button
                      type="icon"
                      icon="swap_horiz"
                      variant="text"
                      onClick={() => setActiveModal("changeInvoice")}
                    />
                    <Button
                      type="icon"
                      icon="alarm"
                      variant="text"
                      onClick={() => setActiveModal("reminder")}
                    />
                    <Button
                      type="icon"
                      icon="sticky_note"
                      variant="text"
                      onClick={() => setActiveModal("note")}
                    />
                    <Button
                      type="icon"
                      icon="stacked_email"
                      variant="text"
                      onClick={() => setActiveModal("email")}
                    /> */}
                    {/* <Button
                type="icon"
                icon={qb}
                variant="text"
                color="black"
                onClick={() => setActiveModal("addQb")}
              /> */}
                    {/* <button onClick={() => setActiveModal("addQb")} className="mx-1"> */}
                    {/* <button onClick={() => handleQbSync("invoices")} className="mx-1">
                <Avatar src={qb} alt={"qb"} size="xs" outline />
              </button>*/}
                    {/* <button
                      onClick={() => handleQbDispatchSync()}
                      className="mx-1"
                    >
                      <Avatar alt={"sync"} size="xs" outline />
                    </button> */}
                      {selectedRowIds?.length > 0 && (
                        <>
                          <Button
                            title="Sync to QB"
                            color="success"
                            onClick={() => handleQbDispatchSync()}
                          />
                        </>
                      )}

                    <Button
                      type="icon"
                      icon="delete"
                      variant="text"
                      onClick={() => setActiveModal("delete")}
                    />
                  </div>
                ),
              },
            ],
          }}
          page={page}
          limit={limit}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          serverSerchValue={searchValue}
          serverOnSearch={handleSearch}
        />
      )}
      <InvoiceModals
        activeModal={activeModal}
        handleCloseModal={handleCloseModal}
      />
      <InvoiceViewModal
        isOpen={viewModal}
        onClose={() => setViewModal(false)}
        invoiceData={currentInvoices}
      />
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
      <QbAnimationLoading
        isOpen={qbLoading}
        onClose={() => setQbLoading(false)}
      />
      {isResendModalOpen && (
        <ResendModal
          open={isResendModalOpen}
          onClose={() => setIsResendModalOpen(false)}
          toEmail={
            currentInvoices?.clientId?.roleContacts
              ?.filter((data) => data.role === "Accounts")
              ?.flatMap((item) => item.email) || []
          }
          ccEmail={currentInvoices?.jobId?.invoices?.cc || []}
          templateName="invoice_created"
          data={{
            orgLogo: loginUserData?.organizationId?.logo?.company || "",
            orgName: loginUserData?.organizationId?.name || "",
            invoiceNum: currentInvoices?.invoiceNum || "",
            client: currentInvoices?.clientId?.businessName || "",
            dueDate: dayjs(currentInvoices?.dueDate).format("MM/DD/YYYY") || "",
            invoiceDate:
              dayjs(currentInvoices?.invoiceDate).format("MM/DD/YYYY") || "",
            // dueDate: dateFormator(currentInvoices?.dueDate) || "",
            // invoiceDate: dateFormator(currentInvoices?.dueDate),
            amount: formatCurrency(currentInvoices?.amounts?.invoiced) || "",
            invoiceUrl: `${window.location.origin}/view/${loginUserData?.organizationId?.uiid}/${currentInvoices?._id}`,
          }}
          isMailSaving={isMailSaving}
          handleSave={(mailDetails) =>
            handleResendInvoice(
              mailDetails,
              currentInvoices,
              setIsMailSaving,
              setIsResendModalOpen,
            )
          }
        />
      )}
    </div>
  );
};

export default AllInvoices;
